import _ from 'lodash'

export default function generateCSV (assetData, freq) {
  // console.log(assetData);
  var LINE_BREAK = '\n'
  var csvContent = ''
  var type = assetData.type || 'textResponses'
  var depth = 0
  // Populate basic header info

  // check depth
  checkDepth(assetData.answers.find(function (answer) {
    return answer.type !== 'group' || (answer.children && answer.children.length > 0)
  }))
  // only supporting up to a 2nd level of segmenting

  var ANS_COL = freq ? '"WORD",' : '"ANSWER",'

  switch (depth) {
    case 0:
      csvContent += ANS_COL
      break
    case 1:
      csvContent += '"SEGMENT ANSWER",' + ANS_COL
      break
    case 2:
      csvContent += '"SECOND SEGMENT ANSWER","SEGMENT ANSWER",' + ANS_COL
      break
    default:
      break
  }
  csvContent += freq ? '"FREQUENCY (%)"' : '"AGE", "GENDER", "HHI", "EMPLOYMENT"'
  csvContent += LINE_BREAK

  if ((type === 'textResponses' || type === 'textFrequency') && assetData && assetData.answers) {
    // Assume textresponses since all legacy json data is textresponses
    // Ungrouped text answers
    assetData.answers.forEach(function (ans) {
      if (ans.type === 'group') iterateGroup(ans)
      else generateRow(ans)
    })
  }
  csvContent.replace('"', "'")

  // recursively check how many layers are nested
  function checkDepth (answer) {
    if (answer === undefined) return false
    if (answer.type === 'group') {
      depth += 1
      // find first child that has children
      var child = answer.children.find(function (kiddo) {
        return kiddo.children && kiddo.children.length > 0
      })
      checkDepth(child)
    }
  }

  function generateRow (row, group, subGroup) {
    // console.log('generating row', row.content, group, subGroup);
    if (!row || !row.show) {
      return false
    }

    if (!_.isUndefined(group) && !_.isString(group)) {
      group = group.toString()
    }

    if (!_.isUndefined(subGroup) && !_.isString(subGroup)) {
      subGroup = subGroup.toString()
    }

    // add extra columns if multiple levels found
    if (group) csvContent += '"' + group.replace(/\n|\r|\r\n|<\/?\s?br\s?\/?>/gmi, ' ').replace(/\"/gmi, "'") + '",'
    if (subGroup) csvContent += '"' + subGroup.replace(/\n|\r|\r\n|<\/?\s?br\s?\/?>/gmi, ' ').replace(/\"/gmi, "'") + '",'

    if (freq) {
      var answers = row.content.replace(/\n|\r|\r\n|<\/?\s?br\s?\/?>/gmi, ' ').replace(/\"/gmi, "'").split(' - ')
      _.forEach(answers, function (ans, idx) {
        if (idx > 0) csvContent += ','
        csvContent += '"' + ans + '"'
      })
    } else {
      var answer = '"' + row.content.replace(/\n|\r|\r\n|<\/?\s?br\s?\/?>/gmi, ' ').replace(/\"/gmi, "'") + '"'
      csvContent += answer
      _.forEach(row.vendor_demographics, function (demo, key) { csvContent += ',' + demo })
    }

    csvContent += LINE_BREAK
  }

  function iterateGroup (ans, group, subGroup) {
    // console.log('iterating group', group, subGroup);
    if (ans.children.length === 0) return // don't print out segments with no data
    group = group || ans.content
    ans.children.forEach(function (child) {
      if (child.type === 'group') {
        subGroup = child.content
        iterateGroup(child, group, subGroup)
      } else generateRow(child, group, subGroup)
    })
  }
  return csvContent
}
